<template>
    <div>
        <el-dialog v-dialog-drag :title="title" :visible.sync="showDialog" width="1100px" :destroy-on-close="true"
            :before-close="cancel">
            <div>
                <el-form class="formDiv" label-width="145px" ref="formContract" :model="formContract"
                    :rules="rulesContract">
                    <el-form-item label="合同编号" prop="contractNumber">
                        <div style="display:flex;align-items: center">
                            <el-input v-model="formContract.contractNumber" auto-complete="off" disabled :readonly=true
                                placeholder="请获取合同编号">
                            </el-input>
                            <el-tooltip content="复制">
                                <a-icon type="copy" style="color: #3f9dfe"
                                    @click="copyData(formContract.contractNumber)" />
                            </el-tooltip>
                            <el-tooltip content="重新获取" v-if="!formContract.contractNumber">
                                <a @click="copyData(formContract.contractNumber)">
                                    <i class="el-icon-refresh" style="color: #3f9dfe"></i></a>
                            </el-tooltip>
                        </div>
                    </el-form-item>
                    <el-form-item label="合同分类" prop="contractTypeName">
                        <el-input readonly v-model="formContract.contractTypeName" auto-complete="off"
                            placeholder="请输入合同分类" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="合同拟定时间" prop="contractDraftingDate">
                        <el-input v-model="formContract.contractDraftingDate" auto-complete="off"
                            placeholder="请输入日期,格式yyyy-MM-dd"></el-input>
                    </el-form-item>
                    <el-form-item label="合同金额" prop="contractAmount">
                        <el-input v-model="formContract.contractAmount" auto-complete="off"
                            placeholder="请输入合同金额"></el-input>
                    </el-form-item>

                    <el-form-item prop="contractName">
                        <template #label>
                            <div style="position: relative; display: inline-block;margin-right: 10px;">
                                <span>合同名称</span>
                                <el-popover placement="top" width="200" trigger="click"
                                    content="不支持使用<  >  :  &quot;  /  \  |  ?  *  +；仅支持数字/汉字/英文/( - _ )等">
                                    <sup slot="reference"
                                        style="position: absolute; top: 10px; right: -15px; cursor: pointer;">
                                        <i class="el-icon-info" style="color: #409EFF; font-size: 14px;"></i>
                                    </sup>
                                </el-popover>
                            </div>
                        </template>
                        <div style="display:flex;align-items: center">
                            <el-input v-model="formContract.contractName" auto-complete="off"
                                placeholder="请输入合同名称"></el-input>
                            <el-button type="primary" style="margin-left: 10px" size="mini"
                                @click="createName">生成</el-button>
                        </div>
                    </el-form-item>
                    <div style="width: 100%;margin-left: 45px;font-size: 14px;color: red;margin-bottom: 10px;">
                        {{'注：合同名称不支持使用<> : " / \\ | ? * + 字符，仅支持数字/汉字/英文/( - _ )等' }}</div>
                    <el-form-item label="合同附件" prop="contractFilePath" style="width: 98%!important;">
                        <div style="display: flex;align-items: center">
                            <el-input v-model="contractFileName" style="width: 81%!important;" readonly></el-input>
                            <el-upload class="upload-demo" action="" :auto-upload="false" :show-file-list="false"
                                :on-change="(...event) => { handleChange(event, 'contract') }"
                                style="width: 9%!important;margin-left: 10px;" :file-list="contractFileList">
                                <el-button size="small" type="primary">选择文件</el-button>
                            </el-upload>
                            <el-button size="small" type="danger" style="width: 9%!important;margin-left: 10px;"
                                @click=" handleRemove('contract')">删除文件</el-button>
                        </div>
                    </el-form-item>

                    <el-form-item style="width: 98%!important;" label="合同备注" prop="remark">
                        <el-input :autosize="{ minRows: 3 }" type="textarea" placeholder="请输入内容"
                            v-model="formContract.remark" maxlength="300" show-word-limit>
                        </el-input>
                    </el-form-item>
                    <div style="width: 98%; display: flex; align-items: center;">
                        <!-- 付款方 -->
                        <div style="width: 45%!important;">
                            <div style="text-align: center; font-weight: bold; margin-bottom: 10px;">付款方</div>
                            <div style="border: 1px dashed #d9d9d9; padding: 20px 0;">
                                <el-form-item label="客户销售" prop="salesId" style="width: 98%!important;">
                                    <el-select v-model="formContract.salesId" placeholder="请选择付款方客户销售" filterable>
                                        <el-option v-for="item in salesOption" :key="item.uuid" :label="item.name"
                                            :value="item.uuid"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="客户联系人" prop="customerContactsId" style="width: 98%!important;">
                                    <el-select v-model="formContract.customerContactsId"
                                        @change="getRemainingAmount(formContract.customerContactsId, 'remainingAmount')"
                                        placeholder="请先选择付款方客户销售" filterable>
                                        <el-option v-for="item in outContactsOption" :key="item.id"
                                            :label="item.contactName + '-' + item.companyName"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="可扣款金额" prop="remainingAmount" style="width: 98%!important;">
                                    <el-input disabled v-model="formContract.remainingAmount"></el-input>
                                </el-form-item>
                            </div>
                        </div>

                        <!-- 中间箭头 -->
                        <div style="width: 10%; display: flex; justify-content: center; align-items: center;">
                            <i class="el-icon-right"></i>
                        </div>

                        <!-- 收款方 -->
                        <div style="width: 45%!important;">
                            <div style="text-align: center; font-weight: bold; margin-bottom: 10px;">收款方</div>
                            <div style="border: 1px dashed #d9d9d9; padding: 20px 0;">
                                <el-form-item label="客户销售" prop="incomingSalesId" style="width: 98%!important;">
                                    <el-select v-model="formContract.incomingSalesId" placeholder="请选择收款方客户销售"
                                        filterable>
                                        <el-option v-for="item in salesOption" :key="item.uuid" :label="item.name"
                                            :value="item.uuid"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="客户联系人" prop="incomingContactsId" style="width: 98%!important;">
                                    <el-select v-model="formContract.incomingContactsId" placeholder="请先选择收款方客户销售"
                                        @change="getRemainingAmount(formContract.incomingContactsId, 'incomingRemainingAmount')"
                                        filterable>
                                        <el-option v-for="item in inContactsOption" :key="item.id"
                                            :label="item.contactName + '-' + item.companyName"
                                            :value="item.id"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="剩余金额" prop="incomingRemainingAmount" style="width: 98%!important;">
                                    <el-input disabled v-model="formContract.incomingRemainingAmount"></el-input>
                                </el-form-item>
                            </div>
                        </div>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" class="title" @click="cancel">取消</el-button>
                <el-button size="small" type="success" class="title" @click="handle">提交</el-button>
            </div>
        </el-dialog>
        <div v-show="loading" v-loading="loading" element-loading-text="提交中" element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.5)"
            style="position: fixed;top:50%;left:50%;transform: translate(-50%, -50%); background-color: rgba(0, 0, 0, .1); width: 300px;height: 250px;z-index: 10000; ">
        </div>
    </div>
</template>
<script>

import { getContractNumber, addTransferContract } from "@/api/dilivery/sales/contract";
import { padDate } from "@/store/date";
import { checkDate, checkNum,checkCharacter } from "@/utils/rules";
import { copyText } from "@/utils/windowsUtils";
import { getPersonByType } from "@/api/dilivery/customer/person";
import { getUserAmountById, getUserById } from "@/api/dilivery/customer/user";

export default {
    name: "CreateTransfer",
    props: ['showDialog'],
    data() {
        return {
            title: '预付款转移合同生成',
            contractFileList: [],
            contractFileName: '',
            loading: false,
            salesOption: [],
            outContactsOption: [],
            inContactsOption: [],
            DateOptions: [
                { label: '1', name: '1年' },
            ],
            TypeOptions: [
                { label: 'ADVANCE_PAYMENT_TRANSFER', name: '预付款转移' },
            ],
            formContract: {
                contractFilePath: null,
                contractTypeName: '预付款转移',
                contractNumber: '',
                expirationDate: '1',
                contractName: '',
                contractAmount: '',
                salesId: '',
                customerContactsId: '',
                incomingSalesId: '',
                incomingContactsId: '',
                contractType: 'ADVANCE_PAYMENT_TRANSFER',
                contractDraftingDate: '',
                signingPlace: '',
                remainingAmount: '',
                projectType: '转移合同扣款',
                specificProjectType: [],
                generateContractInfo: {},
                moreAnalysisRequest: {},
                specificProjectType: [],
                moreAnalysis: [],
                materials: [],
                pureAnalysisEvaluateId: '',
                remark: '',
                incomingRemainingAmount: ''
            },
            rulesContract: {
                contractNumber: [
                    { required: true, message: '请获取合同编号', trigger: 'change' }
                ],

                contractName: [
                    { required: true, message: '请输入合同名称', trigger: 'change' },
                    { validator: checkCharacter, trigger: 'change' }
                ],
                contractAmount: [
                    { required: true, message: '请输入合同金额', trigger: 'change' },
                    { validator: checkNum, trigger: 'change' }
                ],
                salesId: [
                    { required: true, message: '请选择付款方客户销售', trigger: 'change' }
                ],
                customerContactsId: [
                    { required: true, message: '请选择付款方客户联系人', trigger: 'change' }
                ],
                incomingSalesId: [
                    { required: true, message: '请选择收款方客户销售', trigger: 'change' }
                ],
                incomingContactsId: [
                    { required: true, message: '请选择收款方客户联系人', trigger: 'change' }
                ],
                contractDraftingDate: [
                    { required: true, message: '请选择合同拟定时间', trigger: 'change' },
                    { validator: checkDate, trigger: 'change' }
                ]
            },
        }
    },
    watch: {
        'formContract.salesId': {
            handler(newVal, oldVal) {
                if (newVal !== oldVal && oldVal !== '') {
                    this.formContract.customerContactsId = ''
                    this.getRemainingAmount('', 'remainingAmount')
                }
                if (newVal && newVal !== '') {
                    this.getContactsOption(newVal, 'outContactsOption')
                } else {
                    this.formContract.customerContactsId = ''
                    this.getRemainingAmount('', 'remainingAmount')
                    this.outContactsOption = []
                }
            },
            // immediate: true
        },
        'formContract.incomingSalesId': {
            handler(newVal, oldVal) {
                if (newVal !== oldVal && oldVal !== '') {
                    this.formContract.incomingContactsId = ''
                    this.getRemainingAmount('', 'incomingRemainingAmount')
                }
                if (newVal && newVal !== '') {
                    this.getContactsOption(newVal, 'inContactsOption')
                } else {
                    this.formContract.incomingContactsId = ''
                    this.getRemainingAmount('', 'incomingRemainingAmount')
                    this.inContactsOption = []
                }
            },
            // immediate: true
        },
    },
    mounted() {
        if (this.formContract.contractDraftingDate === '') {
            this.formContract.contractDraftingDate = this.getCurrentDate('sign')
        }
        this.generateCode('ADVANCE_PAYMENT_TRANSFER')
        this.getSalesOption()
    },
    methods: {
        async createName() {
            try {
                await this.validateField('salesId');
                await this.validateField('customerContactsId');
                await this.validateField('incomingSalesId');
                await this.validateField('incomingContactsId');
                const salesName = this.salesOption.find(item => item.uuid === this.formContract.salesId).name
                const outName = this.outContactsOption.find(item => item.id === this.formContract.customerContactsId).contactName
                const inSalesName = this.salesOption.find(item => item.uuid === this.formContract.incomingSalesId).name
                const inName = this.inContactsOption.find(item => item.id === this.formContract.incomingContactsId).contactName
                this.formContract.contractName = salesName + '-' + outName + '-' + '转移' + '-' + inSalesName + '-' + inName
            } catch (error) {
                console.log(error);
                this.$messageUi.error('填写参数不规范，请检查')
            }
        },
        validateField(prop) {
            return new Promise((resolve, reject) => {
                this.$refs.formContract.validateField(prop, (error) => {
                    if (error) {
                        reject(error);
                    } else {
                        resolve();
                    }
                });
            });
        },
        handleRemove(type) {
            switch (type) {
                case 'contract':
                    this.formContract.contractFilePath = null;
                    this.contractFileList = []
                    this.contractFileName = ''
                    break
                default:
                    break
            }
        },
        handleChange(files, type) {
            switch (type) {
                case 'contract':
                    this.formContract.contractFilePath = files[0];
                    this.contractFileList = [files[0]]
                    this.contractFileName = files[0].name
                    break
                default:
                    break
            }
        },
        generateCode(type) {
            if (type) {
                getContractNumber(type).then(res => {
                    if (res.code === 200) {
                        this.formContract.contractNumber = res.data
                    }
                }).catch(err => {
                })
            } else {
                this.$messageUi.error('未选择合同分类');
            }
        },
        getContactsOption(salesId, type) {
            try {
                getUserById(salesId).then(res => {
                    if (res.code === 200) {
                        this[type] = res.data;
                    }
                }).catch(err => { })
            } catch (error) {
                console.log(error);
                this.$messageUi.error('获取客户信息失败');
            }
        },
        getRemainingAmount(contactId, type) {
            if (contactId) {
                let params = {
                    contactId: contactId,
                    applyContractId: '',
                    successContractId: ''
                }
                getUserAmountById(params).then(res => {
                    if (res.code === 200) {
                        this.formContract[type] = res.data
                    } else {
                        this.formContract[type] = 0
                    }
                }).catch(err => { })
            } else {
                this.formContract[type] = 0
            }
        },
        getSalesOption() {
            try {
                getPersonByType('SALES', {}).then(res => {
                    if (res.code === 200) {
                        this.salesOption = res.data;
                    }
                }).catch(err => { })

            } catch (error) {
                console.log(error);
                this.$messageUi.error('获取销售信息失败');
            }
        },
        validateForm(ref) {
            return new Promise((resolve) => {
                this.$refs[ref]['validate']((valid) => {
                    resolve(valid);
                });
            });
        },
        getCurrentDate(data) {
            const date = new Date();
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份从 0 开始, September == 8
            const day = date.getDate().toString().padStart(2, '0'); // 日期
            if (data === 'sign') {
                return `${year}-${month}-${day}`
            } else {
                return `${year}${month}${day}`
            }
        },
        // 复制
        copyData(text) {
            copyText(text)
            this.$messageUi.success('复制成功')
        },
        cancel() {
            this.$emit('submit', 'cancel')
        },
        async handle() {
            try {
                this.loading = true
                let remainingAmount = Number(this.formContract.remainingAmount)
                if (Number(this.formContract.contractAmount) > Number(remainingAmount)) {
                    this.$messageUi.error('合同金额大于付款方剩余金额，请检查')
                    this.loading = false
                    return
                }
                // 表单验证
                const [contractFormValid] = await Promise.all([
                    this.validateForm('formContract'),
                ]);
                if (contractFormValid) {
                    const formContract = { ...this.formContract }
                    formContract.contractDraftingDate = padDate(formContract.contractDraftingDate)
                    const formData = new FormData();
                    if (formContract.contractFilePath) {
                        formData.append('contractFile', formContract.contractFilePath.raw); // 文件
                    }

                    const jsonStrContract = JSON.stringify(
                        Object.keys(formContract).reduce((acc, key) => {
                            if (!['contractFilePath'].includes(key)) {
                                acc[key] = formContract[key];
                            }
                            return acc;
                        }, {})
                    );
                    const blobContract = new Blob([jsonStrContract], {
                        type: 'application/json'
                    });
                    formData.append("contractInfo", blobContract);
                    // 添加以及草稿的编辑
                    addTransferContract(formData).then(res => {
                        this.loading = false
                        if (res.code === 200) {
                            this.$messageUi.success('提交成功')
                            this.$emit('submit', 'confirm')
                            this.$store.commit('right/setChangeRed', true)
                        }
                    }).catch(err => {
                        this.loading = false
                    })
                } else {
                    this.loading = false
                    this.$nextTick(() => {
                        let err = document.getElementsByClassName('is-error')
                        if (err.length) {
                            err[0].scrollIntoView({
                                block: 'center',
                                behavior: 'smooth',
                            })
                        }
                    })
                    this.$messageUi.error('填写参数不规范，请检查')
                }
            } catch (error) {
                console.log(error);
                this.loading = false
                this.$messageUi.error('提交失败，请稍后再试！')
            }
        },
    },
}
</script>

<style scoped>
.formDiv {
    display: flex;
    flex-wrap: wrap;
}

.el-form-item {
    width: 49% !important;
}

.el-select {
    width: 100%;
}

.el-form-item__label {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex: 1;
}

.el-input.is-disabled .el-input__icon {
    display: none;
}

/*.formDiv .el*/
</style>